import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { ref, get } from 'firebase/database';
import { database, DB_PATHS } from '../config/firebase';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/slices/authSlice';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [phonenumber, setPhonenumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      // manager 테이블에서 전화번호로 사용자 정보 조회
      const managerRef = ref(database, `${DB_PATHS.MANAGER}/${phonenumber}`);
      const snapshot = await get(managerRef);

      if (!snapshot.exists()) {
        setError('존재하지 않는 계정입니다.');
        return;
      }

      const managerData = snapshot.val();

      // 비밀번호 확인
      if (managerData.password !== password) {
        setError('비밀번호가 일치하지 않습니다.');
        return;
      }

      // 계정 차단 여부 확인
      if (managerData.block === 'true') {
        setError('차단된 계정입니다.');
        return;
      }

      // 로그인 성공 시 Redux store에 사용자 정보 저장
      dispatch(setUser({
        id: phonenumber,
        username: managerData.username,
        grade: managerData.grade,
        appname: managerData.appname,
        referralcode: managerData.referralcode
      }));

      // 로그인 성공 시 drivers 페이지로 이동
      navigate('/driverspage');
    } catch (error) {
      console.error('Login error:', error);
      setError('로그인 중 오류가 발생했습니다.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 2,
        backgroundColor: '#f5f5f5'
      }}
    >
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          width: '100%',
          maxWidth: 400,
          padding: 4,
          backgroundColor: 'white',
          borderRadius: 2,
          boxShadow: 3
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom align="center">
          SMLink Manager
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          fullWidth
          label="전화번호"
          value={phonenumber}
          onChange={(e) => setPhonenumber(e.target.value)}
          margin="normal"
          required
          placeholder="01012345678"
        />

        <TextField
          fullWidth
          label="비밀번호"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          required
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
        >
          로그인
        </Button>
      </Box>
    </Box>
  );
};

export default Login; 